'use client';

import { initSentryClient } from 'app/utils/sentry';

// Una vez por carga de pagina, en el navegador. Next 14 no lee instrumentation-client.ts.
if (typeof window !== 'undefined') {
  initSentryClient();
}

export default function SentryInit() {
  return null;
}
